module.exports = __webpack_public_path__ + "img/asbach_gemälde_2019_ref.7eb7119e.jpg";